import { render, staticRenderFns } from "./Uncertainty.vue?vue&type=template&id=2f22791e&scoped=true&"
import script from "./Uncertainty.vue?vue&type=script&lang=ts&"
export * from "./Uncertainty.vue?vue&type=script&lang=ts&"
import style0 from "./Uncertainty.vue?vue&type=style&index=0&id=2f22791e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22791e",
  null
  
)

export default component.exports